import { configureStore } from '@reduxjs/toolkit';
import appReducer from './reducers/appReducer';

export const store = configureStore({
  reducer: {
    app: appReducer, // Ensure this is an object with reducers
  },
});

export default store;
